import { Injectable } from '@angular/core';
import { globalEnv } from '../../connection/global/global.env';
import { Observable } from 'rxjs';
import { countrySelect } from '../../api/country-select/country-select';
import { BaseService } from 'src/app/data/handlers/base-service/base.service';
import { map } from 'rxjs/operators';
import { GenericResponse } from '../../models/base-service/base-service';
import { CountrySelect } from '../../models/country-select/country-select';

@Injectable({
  providedIn: 'root'
})
export class CountrySelectService {
  constructor(private baseService: BaseService) { }

  getCountries(): Observable<CountrySelect[]> {
    return this.baseService
      .get<GenericResponse<CountrySelect[]>>(`${globalEnv.multiCountry}${countrySelect.flag_properties}`)
      .pipe(map(response => response.data));
  }

}
